export const createHeader = async () => {
  const header = document.querySelector("[data-header]");

  if (header === null) {
    return;
  }

  const controller = new AbortController();

  const state = {
    scrollY: -1,
  };

  const update = () => {
    requestAnimationFrame(() => {
      if (state.scrollY === -1) {
        state.scrollY = window.scrollY;
      }

      const delta = Math.floor(state.scrollY - window.scrollY);

      state.scrollY = window.scrollY;

      const isVisible = window.scrollY > 0 && delta >= 0;

      header.classList.toggle("is-visible", isVisible);
    });
  };

  window.addEventListener("scroll", update, {
    signal: controller.signal,
    passive: true,
  });

  window.addEventListener("resize", update, {
    signal: controller.signal,
    passive: true,
  });

  const burger = document.querySelector("[data-menu-toggle]");

  burger?.addEventListener("click", async () => {
    if (burger.classList.contains("is-active") === false) {
      burger.classList.add("is-active");

      const { createMobileMenu } =
        await import("@/components/mobile-menu/mobile-menu");

      createMobileMenu({
        onClose: () => {
          burger.classList.remove("is-active");
        },
      });
    }
  });
};
